module.exports = __webpack_public_path__ + "media/images/parent-nanny-signup-9756aafbfd09c224bd937182d3be801a.jpg";